import { createContext } from "react";
const StepsContext = createContext({});
export default StepsContext;
